@let data = section();

<section class="cms-stories tg-section">
    @if (data.content) {
        <div class="cms-stories__intro">
            <div class="cms-content" [innerHTML]="data.content | trustHtml"></div>
        </div>
    }

    <div class="cms-stories__grid">
        @for (story of data.storiesList; track story.id) {
            <article class="cms-stories__card">
                <div class="cms-stories__head">
                    @if (story.avatarImg?.url) {
                        <cms-image class="cms-stories__avatar" sizes="104px" [media]="story.avatarImg" />
                    } @else {
                        <span
                            class="cms-stories__avatar cms-stories__avatar--placeholder"
                            aria-hidden="true"
                        ></span>
                    }
                    <div class="cms-stories__meta">
                        <p class="cms-stories__name tg-h3">{{ story.fullName }}</p>
                        @if (story.shortInfo) {
                            <p class="cms-stories__role tg-caption">{{ story.shortInfo }}</p>
                        }
                    </div>
                </div>

                @if (story.story) {
                    <div class="cms-content" [innerHTML]="story.story | trustHtml"></div>
                }
            </article>
        }
    </div>
</section>
